import BonusNew from './BonusNew';

export default BonusNew;
